import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import LiterarySidebar from '../Literaryclub2023/components/LiterarySidebar';
import Sidebar2025 from '../Literaryclub2023/components/Sidebar2025';

const EnglishCCAClass3to52025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/6.webp`;
    const p7 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/7.webp`;
    const p8 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/8.webp`;
    const p9 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/EnglishCCA3to5/9.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
        {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 1,
            cols: 1,
        }
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                               
<br></br>
                                    <Typography variant='h7' align='justify' >
                                    Class 3-Story Quest – Arrange and Act     
                                    <br></br>
                                    Class 4-Strings of Imagination – Puppet Tales with a Twist
                                    <br></br>
                                   Class 5-Character Cameo – Live the Story
                                    </Typography>
                                    <br></br>            
                                                                            
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                  Classes: 3 to 5   &  Date : 22 July 2026- 24 July 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "Love nature and be kind to animals"

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The English CCA competitions for Classes 3, 4 and 5 took place from Wednesday, 22 July 2026 to  Friday, 24 July 2026. The competitions provided a vibrant platform for students to showcase their creativity, language proficiency, collaboration and self-expression through engaging, activity-based learning experiences. 
                                                                <br></br>
                               <strong> Story Quest – Arrange and Act</strong> for Class 3 encouraged students to bring stories to life through expressive role-play, logical sequencing and confident narration.
                                                                <br></br>
                               <strong> Strings of Imagination – Puppet Tales with a Twist</strong>for Class 4 inspired teams to present imaginative puppet shows by creatively incorporating an additional character and a surprise challenge while maintaining a coherent storyline. 
                                 <br></br>
                               <strong> Character Cameo – Live the Story</strong> for Class 5 celebrated collaboration and creativity as students brought together characters from different well-known stories to create original performances that highlighted values such as friendship, teamwork, honesty and compassion.
                                <br></br>
                                 The competitions strengthened students' speaking skills, expressions, collaboration and critical thinking skills while fostering confidence, imagination and stage presence, making the English CCA Finals a memorable celebration of creativity and learning.    
                                <br></br>

                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                               Great stories are imagined, brought to life through performances and transformed into memorable experiences that inspire learning.

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 500 : 300}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        
                        <Box marginBottomSidebar2025={4}>
                            <Sidebar2025/>
                        </Box>
                        {/* <Box marginBottom={4}>
                                    <Archive2023/>
                        </Box> */}
                        <Box marginBottom={4}>
                                    <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default EnglishCCAClass3to52025;